import ReactDom from 'react-dom';

import { Icon as BlueIcon } from '@blueprintjs/core';

import { useMutation, useQueryClient } from 'react-query';

import { useParams } from 'react-router-dom';
import { changeUpdateStatus } from '@services/queries/updates/changeUpdateStatus/changeUpdateStatus';
import { UpdateStatusType } from '@models/UpdateStatus.model';
import { changeUpdateStatusByUpdate } from '@services/queries/updates';
import { NavigationContext } from '@layout/navigation/navigation';
import { useContext } from 'react';
import { useToast } from '@hooks';

import { addUpdatedUpdate } from '@store/redux/features/updatesOptimistic';
import { useDispatch } from 'react-redux';
import { addBackUpUpdatedUpdates } from '@store/redux/features/updatesOptimistic/updatesOptimisticSlice';
import {
  Container,
  Overlay,
  Close,
  Header,
  Title,
  Confirm,
  Line,
  Form,
  Divider,
  Label,
} from './MarkAsCompleteDialog.styles';

interface IMarkAsCompleteDialog {
  open: boolean;
  onClose: () => void;
  updateStatusId?: string;
  updateId?: string;
  closeOnFinish?: boolean;
}

export const MarkAsCompleteDialog = ({
  open,
  onClose,
  updateStatusId,
  updateId,
  closeOnFinish = true,
}: IMarkAsCompleteDialog) => {
  const portalDiv = document.getElementById('portal');

  const { toast } = useToast();

  const { studioId, updatesMtViewTime } = useContext(NavigationContext);

  const params = useParams<{ id: string; equipmentId: string }>();

  const queryClient = useQueryClient();

  const reloadQueries = async () => {
    queryClient.invalidateQueries(['updateStatuses', updateId]);

    toast.success('Update changed successfully');
    if (updateId)
      if (updateId)
        // dispatch(addUpdatesLoadingUpdateId(updateId));
        // await sleep(updatesMtViewTime * 1000);
        // dispatch(removeUpdatesLoadingUpdateId(updateId));

        queryClient.invalidateQueries(['updateStatuses']);
    queryClient.invalidateQueries(['updatesMetrics']);
    queryClient.invalidateQueries(['studios', params.id, 'updateStatuses']);
    queryClient.invalidateQueries([
      'equipments',
      params.equipmentId,
      'updateStatuses',
    ]);
  };

  const dispatch = useDispatch();

  const mutationByUpdate = useMutation(changeUpdateStatusByUpdate, {
    onSuccess: async newUpdate => {
      if (closeOnFinish) {
        onClose();
      }
      dispatch(addBackUpUpdatedUpdates(newUpdate));

      dispatch(addUpdatedUpdate({ newUpdate, updatesMtViewTime }));
      reloadQueries();
    },
    onError: () => {
      toast.success('Something got wrong');
    },
  });

  const mutation = useMutation(changeUpdateStatus, {
    onSuccess: async newUpdate => {
      if (closeOnFinish) {
        onClose();
      }
      dispatch(addBackUpUpdatedUpdates(newUpdate));

      dispatch(addUpdatedUpdate({ newUpdate, updatesMtViewTime }));
      reloadQueries();
    },
    onError: () => {
      toast.success('Something got wrong');
    },
  });

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header>
              <Title>Mark as Complete</Title>
              <Close onClick={onClose}>
                <BlueIcon icon="cross" color="#8F95B2" />
              </Close>
            </Header>
            <Divider height="28px" />

            <Label>
              This action will mark it as done for all assets. Ensure the update
              has been done on all affected items before complete
            </Label>

            <Form>
              <Line>
                <Confirm
                  type="button"
                  onClick={() => {
                    if (!mutation.isLoading && !mutationByUpdate.isLoading) {
                      if (updateStatusId) {
                        mutation.mutate({
                          updateStatusId,
                          type: UpdateStatusType.COMPLETED,
                        });
                      } else {
                        mutationByUpdate.mutate({
                          updateId,
                          studioId,
                          type: UpdateStatusType.COMPLETED,
                        });
                      }
                    }
                  }}
                >
                  Complete
                </Confirm>
              </Line>
            </Form>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
